import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
//import reportWebVitals from "./reportWebVitals";
// Importing the font that is going to be used *Avenir Next*
//import "./static/fonts/AvenirNext.ttf";

// Importing a bold version of the Avenir Next font
//import "./static/fonts/AvenirNext-Bold.ttf";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("store-locator-react")
);
